import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import { Checklist } from "ctia-ui";
import UnderReviewViewBLC from "containers/testResult/UnderReviewViewBLC";
import { isComplete, isUnderReview } from "helpers/RequestTestsHelper";
import PointOfContact from "containers/request/Initial/Steps/Laboratory/PointOfContactLab";
import DeviceInfoLabBLC from "containers/request/BLC/DeviceInfoLabBLC";
import {
  getChecklistInitialBLC,
  getChecklistEcoBLC
} from "helpers/ChecklistBatteryHelper";
import { setBatteryRequestPermissions } from "actions/request";
import BatteryLifeInfoContainer from "containers/request/BLC/BatteryLifeInfoContainer";

class RequestContentLabBLC extends Component {

  componentDidMount() {
    this.props.setBatteryRequestPermissions(
      this.props.request,
      this.props.user
    );
  }

  renderChecklist() {
    const { request } = this.props;
    const checkListInitial = getChecklistInitialBLC(request);
    const checkListEco = getChecklistEcoBLC(request);
    const requestChecklist = request.isInitial
      ? checkListInitial
      : checkListEco;

    return <Checklist list={requestChecklist} />;
  }

  render() {
    const { request, tests } = this.props;
    const testModule = tests[0];
    const testStatus = request.testStatus;
    const showTestResults = isComplete(testStatus) || isUnderReview(testStatus);
    const showBLInfo = request.batteryLifeResult && showTestResults;

    return (
      <Row>
        <Col xs={12} sm={8} md={9}>
          <Tabs defaultActiveKey={1} id="request-edit-tabs">
            <Tab eventKey={1} title="Device Info">
              <DeviceInfoLabBLC />
            </Tab>
            {showBLInfo && (
              <Tab eventKey={2} title="Battery Life Info">
                <BatteryLifeInfoContainer />
              </Tab>
            )}
            <Tab eventKey={3} title="Point of Contact">
              <PointOfContact />
            </Tab>
            {showTestResults && (
              <Tab eventKey={4} title="Test Results">
                <UnderReviewViewBLC
                  show={showTestResults}
                  testModule={testModule}
                  request={request}
                />
              </Tab>
            )}
          </Tabs>
        </Col>
        <Col xs={12} sm={4} md={3}>
          {this.renderChecklist()}
        </Col>
      </Row>
    );
  }
}

function mapStateToProps({ request, tests, user }) {
  return { request, tests, user };
}

export default connect(mapStateToProps, {
  setBatteryRequestPermissions
})(RequestContentLabBLC);
